'use strict';

var avatar = {};

exports.__exports = avatar;
//# sourceMappingURL=avatar.cjs.map
